import $ from 'jquery';

export default () => {
  const awardsLoadMore = $('.js-load-more-gallery');
  const isRtl = $('html').attr('dir') === 'rtl';

  awardsLoadMore.on('click', function(e) {
    e.preventDefault();
    const $this = $(this)
    if (!isRtl) {
      awardsLoadMore.text('LOADING ...');
    } else {
      awardsLoadMore.text('جاري التحميل ...');
    }
  });
};